import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "styling"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { RichText, isChildOfContainerContext } from '@uswitch/ev-core/react';
import richTextFieldHasContent from '@uswitch/ev-utils/rich-text/has-content';
import richTextStyles from '@uswitch/ev-utils/rich-text/styles';
import { ConditionalWrapper } from '@uswitch/ev-utils/conditional-wrapper';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var SimpleContainer = function SimpleContainer(_ref) {
  var children = _ref.children,
      styling = _ref.styling,
      props = _objectWithoutProperties(_ref, _excluded);

  return _jsx("div", _objectSpread(_objectSpread({
    sx: _objectSpread({
      mx: 'auto',
      maxWidth: '1200px',
      paddingX: 'sm'
    }, styling)
  }, props), {}, {
    children: _jsx(isChildOfContainerContext.Provider, {
      value: true,
      children: children
    })
  }));
};

var HeaderFooterWrapper = function HeaderFooterWrapper(_ref2) {
  var heading = _ref2.heading,
      footer = _ref2.footer,
      headerStyles = _ref2.headerStyles,
      footerStyles = _ref2.footerStyles,
      headerContainerStyles = _ref2.headerContainerStyles,
      footerContainerStyles = _ref2.footerContainerStyles,
      children = _ref2.children,
      wrapChildren = _ref2.wrapChildren;
  return _jsxs(_Fragment, {
    children: [richTextFieldHasContent(heading) ? _jsx(ConditionalWrapper, {
      condition: wrapChildren,
      wrapper: SimpleContainer,
      styling: headerContainerStyles,
      children: _jsx(RichText, {
        content: heading,
        style: _objectSpread(_objectSpread({
          display: 'block',
          pb: 'lg'
        }, richTextStyles), headerStyles)
      })
    }) : null, children, richTextFieldHasContent(footer) ? _jsx(ConditionalWrapper, {
      condition: wrapChildren,
      wrapper: SimpleContainer,
      styling: footerContainerStyles,
      children: _jsx(RichText, {
        content: footer,
        style: _objectSpread(_objectSpread({
          display: 'block',
          pt: 'lg'
        }, richTextStyles), footerStyles)
      })
    }) : null]
  });
};

export default HeaderFooterWrapper;
//# sourceMappingURL=header-footer-wrapper.js.map